import { render, staticRenderFns } from "./WHomeMenu.vue?vue&type=template&id=0d7fa6f7&"
import script from "./WHomeMenu.vue?vue&type=script&lang=ts&"
export * from "./WHomeMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports